/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ThreadsControllerUpdateMutationResponse, ThreadsControllerUpdatePathParams, ThreadsControllerUpdate400, ThreadsControllerUpdate401, ThreadsControllerUpdate403, ThreadsControllerUpdate404 } from "../../models/threadsController/ThreadsControllerUpdate";

function getThreadsControllerUpdateUrl(threadId: ThreadsControllerUpdatePathParams["threadId"]) {
  const res = { method: 'PATCH', url: `/api/v1/threads/${threadId}` as const }  
  return res
}

/**
 * @description Update thread properties such as name, description, or pin status.
 * @summary Update a thread
 * {@link /api/v1/threads/:threadId}
 */
export async function threadsControllerUpdate(threadId: ThreadsControllerUpdatePathParams["threadId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ThreadsControllerUpdateMutationResponse, ResponseErrorConfig<ThreadsControllerUpdate400 | ThreadsControllerUpdate401 | ThreadsControllerUpdate403 | ThreadsControllerUpdate404>, unknown>({ method : "PATCH", url : getThreadsControllerUpdateUrl(threadId).url.toString(), ... requestConfig })  
  return res.data
}